module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon_quote_right-2b1d2780bfed4050afe30b7a99b9527b.svg";